var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"import-being-processed"},[_c('global-alert',[_vm._v(" "+_vm._s(_vm.$t("import-being-processed"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }